import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["data-id"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Редактировать блок")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Удалить блок")
const _hoisted_5 = {
  key: 0,
  class: "q-ml-xs"
}
const _hoisted_6 = { class: "text-h6" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Отделить от помещения")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Изменить этаж")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_field = _resolveComponent("q-field")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("div", {
      class: "q-mb-none row point-edit",
      onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectPoint && _ctx.selectPoint(...args)), ["stop"]))
    }, [
      _createElementVNode("span", null, [
        (_ctx.namePointEditing && _ctx.point?.id_point === _ctx.editedPoint)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              _createVNode(_component_q_field, null, {
                control: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    filled: "",
                    type: "text",
                    modelValue: _ctx.newNamePoint,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newNamePoint) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                append: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    size: "xs",
                    color: "standard",
                    "text-color": "black",
                    icon: "save",
                    onClick: _ctx.saveChanges
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_q_btn, {
                    size: "xs",
                    color: "standard",
                    "text-color": "black",
                    icon: "cancel",
                    onClick: _ctx.cancelChanges
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              draggable: true,
              "data-id": _ctx.point?.id_point,
              onDragstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDrag($event))),
              onDragend: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDragging = false)),
              onDrop: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onDropFromExternalWidget($event)), ["prevent"])),
              onDragover: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.isHovered = true), ["prevent"])),
              onDragleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isHovered = false)),
              class: _normalizeClass({
              dragging: _ctx.isDragging,
              hovered: _ctx.isHovered,
          })
            }, [
              _createVNode(_component_q_icon, {
                name: "grain",
                size: "14px"
              }),
              _createVNode(_component_q_icon, {
                name: "radio_button_checked",
                size: "14px"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.point?.name_point) + " ", 1),
              _createVNode(_component_q_menu, {
                "touch-position": "",
                "context-menu": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, {
                    dense: "",
                    style: {"min-width":"100px"}
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { onClick: _ctx.prepareEditNamePoint }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _createVNode(_component_q_icon, { name: "edit" }),
                                _hoisted_3
                              ])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { onClick: _ctx.removePoint }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _createVNode(_component_q_icon, { name: "delete" }),
                                _hoisted_4
                              ])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ]),
                      _createVNode(_component_q_separator),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: "cancel",
                                class: "q-mx-auto"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 42, _hoisted_2))
      ]),
      (!_ctx.namePointEditing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_q_btn_group, { push: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.point?.spaces, (space) => {
                  return (_openBlock(), _createBlock(_component_q_btn, {
                    size: "sm",
                    key: space.id_space,
                    onClick: ($event: any) => (_ctx.showFloorsModal(space)),
                    flat: "",
                    label: space.number_space
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(space.floors, (floor) => {
                        return (_openBlock(), _createBlock(_component_q_badge, {
                          key: floor.id_point_nn_space,
                          color: "black",
                          class: "point-badge",
                          floating: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "layers",
                              size: "10px"
                            }),
                            _createTextVNode(_toDisplayString(floor.floor), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["onClick", "label"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.namePointEditing)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 1,
            name: "more_vert",
            size: "14px",
            class: "context-menu"
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.selectedSpace)
      ? (_openBlock(), _createBlock(_component_q_dialog, {
          key: 0,
          modelValue: _ctx.showFloors,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showFloors) = $event)),
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, { class: "q-pa-md" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, "Этажи " + _toDisplayString(_ctx.selectedSpace.number_space), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("section", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSpace.floors, (floor) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "q-mb-xs",
                      key: floor.id_point_nn_space
                    }, [
                      _createTextVNode(" Этаж: " + _toDisplayString(floor.floor) + " ", 1),
                      (floor.id_point_nn_space !== _ctx.selectedLevel)
                        ? (_openBlock(), _createBlock(_component_q_btn_group, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_btn, {
                                size: "sm",
                                color: "standard",
                                "text-color": "black",
                                class: "q-px-xs",
                                onClick: ($event: any) => (_ctx.unbindPoint(floor))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_q_btn, {
                                size: "sm",
                                color: "standard",
                                "text-color": "black",
                                icon: "delete",
                                class: "q-px-xs",
                                onClick: ($event: any) => (_ctx.initLevelEditing(floor))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_q_field, { key: 1 }, {
                            control: _withCtx(() => [
                              _createVNode(_component_q_input, {
                                filled: "",
                                type: "number",
                                modelValue: _ctx.currentFloor,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentFloor) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            append: _withCtx(() => [
                              _createVNode(_component_q_btn, {
                                size: "sm",
                                color: "standard",
                                "text-color": "black",
                                icon: "save",
                                onClick: _ctx.saveNewLevel
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_q_btn, {
                                size: "sm",
                                color: "standard",
                                "text-color": "black",
                                icon: "cancel",
                                onClick: _ctx.cancelEditing
                              }, null, 8, ["onClick"])
                            ]),
                            _: 1
                          }))
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_q_card_actions, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      size: "sm",
                      color: "standard",
                      "text-color": "black",
                      label: "Отмена"
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}